module.exports = __webpack_public_path__ + "427067109baa8dd7f31e9888d98bdec9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/monster_energy_company_2021_chart.png
// module id = 1688
// module chunks = 0